import { Helmet } from 'react-helmet-async';

interface SEOProps {
    title?: string;
    description?: string;
    image?: string;
}

export const SEO = ({
    title = 'KombinTrendi - En Tarz Kombinler ve İndirimler',
    description = 'TikTok tarzı video akışı ile en moda kombinleri keşfet. Beğendiğin ürünleri tek tıkla Trendyol\'dan incele.',
    image = '/og-image.jpg'
}: SEOProps) => {
    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content="website" />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={image} />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image} />
        </Helmet>
    );
};